import React, { useEffect, useState, useContext, useRef } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import ReactSelect from "react-select";
import makeAnimated from "react-select/animated";
import { Messages } from 'primereact/messages';
import { useMountEffect } from 'primereact/hooks';
import { DefiAppService } from "../../DefiAppService";
import ierc20Abi from "../../contracts/ierc20Abi";
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';

import { SelectButton } from 'primereact/selectbutton';


import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import { formatDecimals, formatCurrencyExtended, abbreviateNumber, getTokenPrice, getTokenDecimals, formatWalletAddress, formatTokenLabel } from '../../utils';
import { miniCardHeaderStyle, refuelInfoInvertStyle, tokenCardStyle, refuelHeaderStyle, refuelOutlineInvertStyle } from "./TileStyles";

import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';

import { Progress } from '@nextui-org/react';

import BigNumber from 'bignumber.js'

const AdminSelection = ({ data, getData }) => {

    // State Variables

    const LoadingContent = () => <Skeleton width="50%" height="35px" className="mb-2" />;
    const LoadingTitle = () => <Skeleton width="25%" height="25px" className="mb-2" />;



    const { library, account } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;
    const isWalletConnected = () => account !== null;

    const [value, setValue] = useState('');
    const [tokenAmount, setTokenAmount] = useState(null);
    const [parsedAddresses, setParsedAddresses] = useState([]);
    const [invalidAddressInputs, setInvalidAddressInputs] = useState(0);
    const [invalidSmartCodeInputs, setInvalidSmartCodeInputs] = useState(0);
    const [validSmartCodeCount, setValidSmartCodeCount] = useState(0);
    const [validAddressCount, setValidAddressCount] = useState(0);
    const [isCalculating, setIsCalculating] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [selectedToken, setSelectedToken] = useState(null);
    const [refuelUserData, setRefuelUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [approved, setApproved] = useState(false);

    const [displayAddress, setDisplayAddress] = useState('');
    const [displaySmartCode, setDisplaySmartCode] = useState('');


    const getRefuelUserData = async () => {
        // console.log("Getting refuel user data for: ", account);
        return await contracts.refuelDepositer.methods.refuelUserData(account).call();
    };

    const tokensPerSmartCode = tokenAmount && parsedAddresses.length > 0
        ? new BigNumber(tokenAmount).div(parsedAddresses.length).toNumber()
        : 0;

    const totalDistributions = parsedAddresses.length; // use the length of the parsed addresses set




    const toast = useRef(null);
    const msgs = useRef(null);



    useEffect(() => {
        if (isWalletConnected() && contracts.refuelDepositer) {
            getRefuelUserData().then((res) => {
                setRefuelUserData(res);
            });
        }
    }, [contracts.refuelDepositer, account]);

    useEffect(() => {
        //console.log("Selected Token:", selectedToken);
        setTokenAmount(null);
    }, [selectedToken]);

    useEffect(() => {
        if (!isCalculating) return;

        const parseInput = async () => {
            // Split the input string into individual codes/addresses and filter out any empty strings
            const inputs = value.split(/[\s,]+/).filter(Boolean);
            const directAddressSet = new Set();
            const smartCodeAddressSet = new Set();
            let invalidAddresses = [];
            let invalidSmartCodes = [];

            let foundSmartCode = false;

            // for (const input of inputs) {
            //     if (Web3.utils.isAddress(input) && input !== "0x0000000000000000000000000000000000000000") {
            //         directAddressSet.add(input.toLowerCase());
            //         try {
            //             const smartCode = await contracts.smartCodes.methods.getSmartCodeByHolder(input).call();
            //             if (smartCode && smartCode !== "0x0") {
            //                 setDisplaySmartCode(smartCode);
            //                 setDisplayAddress('');
            //                 foundSmartCode = true; // Indicates that a valid smart code was found
            //             }
            //         } catch (error) {
            //             console.error("Error fetching smart code for address:", error);
            //             setDisplaySmartCode(''); // Ensure this is cleared if there's an error
            //         }
            //     } else {
            //         const uppercasedInput = input.toUpperCase();
            //         try {
            //             const address = await contracts.smartCodes.methods.getHolderBySmartCode(uppercasedInput).call();
            //             if (address !== "0x0000000000000000000000000000000000000000") {
            //                 smartCodeAddressSet.add(address.toLowerCase());
            //                 setDisplayAddress(address.toLowerCase());
            //                 setDisplaySmartCode('');
            //             } else {
            //                 invalidSmartCodes.push(uppercasedInput);
            //             }
            //         } catch (error) {
            //             invalidAddresses.push(input);
            //         }
            //     }
            // }

            // if (!foundSmartCode && directAddressSet.size > 0) {
            //     setDisplaySmartCode('No Smart Code Found'); // Only set this if no smart codes were found for any address input
            // }
            for (const input of inputs) {
                if (Web3.utils.isAddress(input) && input !== "0x0000000000000000000000000000000000000000") {
                    directAddressSet.add(input.toLowerCase());
                    // Attempt to find a smart code for a valid address
                    try {
                        const smartCode = await contracts.smartCodes.methods.getSmartCodeData(input).call();
                        //console.log("Smart code found:", smartCode[1]);
                        if (smartCode[1] && smartCode[1] !== "") {
                            setDisplaySmartCode(smartCode[1]);
                            setDisplayAddress('');
                        }
                    } catch (error) {
                        console.error("Failed to find smart code for address:", error);
                    }
                } else {
                    const uppercasedInput = input.toUpperCase();
                    try {
                        const address = await contracts.smartCodes.methods.getHolderBySmartCode(uppercasedInput).call();
                        //console.log("Address found:", address);
                        if (address !== "0x0000000000000000000000000000000000000000") {
                            smartCodeAddressSet.add(address.toLowerCase());
                            setDisplayAddress(address.toLowerCase());
                            setDisplaySmartCode('');
                        } else {
                            invalidSmartCodes.push(uppercasedInput);
                        }
                    } catch (error) {
                        invalidAddresses.push(input);
                    }
                }
            }




            setParsedAddresses([...directAddressSet, ...smartCodeAddressSet]);
            setInvalidAddressInputs(invalidAddresses.length);
            setInvalidSmartCodeInputs(invalidSmartCodes.length);
            setValidSmartCodeCount(smartCodeAddressSet.size);
            setValidAddressCount(directAddressSet.size);

            if (invalidAddresses.length > 0 || invalidSmartCodes.length > 0) {
                const invalidAddressesDetail = invalidAddresses.length > 0 ? `${invalidAddresses.join(', ')}. ` : '';
                const invalidSmartCodesDetail = invalidSmartCodes.length > 0 ? `${invalidSmartCodes.join(', ')}.` : '';

                msgs.current.show({
                    severity: 'warn',
                    summary: 'Omitted Invalid Entries:',
                    detail: invalidAddressesDetail + invalidSmartCodesDetail,
                    life: 3000
                });
            }

            // Show success message for valid smart codes
            if (invalidSmartCodes.length === 0 && transferType === options[0]) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Valid Smart Code',
                    detail: `Successfully validated smart codes: ${inputs.join(', ')}.`,
                    life: 3000
                });
            }

            // Show warning message for invalid smart codes
            if (invalidSmartCodes.length > 0 && transferType === options[0]) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Invalid/Incorrect Smart Code',
                    detail: `The following smart codes are invalid or incorrect: ${invalidSmartCodes.join(', ')}.`,
                    life: 3000
                });
            }
        };

        if (value.trim()) parseInput();
        setIsCalculating(false);
        setIsButtonDisabled(true);
    }, [value, contracts.smartCodes, isCalculating]);

    useEffect(() => {
        //check if the tokenamount is approved each time the token amount changes
        if (tokenAmount && selectedToken) {
            checkIfApproved(contracts.refuelDepositer._address, tokenAmount).then((res) => {
                setApproved(res);
            });
            //  console.log("Approved:", approved);
        }
    }
        , [selectedToken, tokenAmount, data]);




    const checkIfApproved = async (address, tokenAmount) => {
        const tokenContract = await buildTokenContract(selectedToken.address);
        //console.log("Token contract:", tokenContract);
        const approvedAmount = await tokenContract.methods.allowance(account, address).call();
        // console.log("Approved amount:", parseFloat(approvedAmount) / 10 ** selectedToken.decimals);
        // console.log("Token Amount", tokenAmount);
        // console.log("Comparing Values:", parseFloat(approvedAmount) / 10 ** selectedToken.decimals >= parseFloat(tokenAmount));
        if (approvedAmount / 10 ** selectedToken.decimals >= tokenAmount) {
            return true;
        } else {
            return false;
        }
    };




    const refreshApproved = () => {
        if (tokenAmount && selectedToken) {
            checkIfApproved(contracts.refuelDepositer._address, tokenAmount).then((res) => {
                setApproved(res);
            });
            //  console.log("Approval Successful:", approved);
        }
    }




    let step;
    if (selectedToken) {
        const fractionOfTotalSupply = selectedToken.balanceOfHolder / 10 ** selectedToken.decimals / selectedToken.totalSupply / 10 ** selectedToken.decimals;
        if (fractionOfTotalSupply > 0.5) {
            step = selectedToken.balanceOfHolder / 10 ** selectedToken.decimals * 0.1; // 10% of their balance
        } else {
            step = selectedToken.balanceOfHolder / 10 ** selectedToken.decimals * 0.01; // 1% of their balance
        }
    } else {
        step = 0;
    }


    //Web3 Hanlders
    const handleDeposit = async (tokenAmount) => {
        if (!isWalletConnected()) {
            console.error("Please connect to a wallet before interacting with the contract.");
            return;
        }
        //verify if approval is needed, if it is needed, execute approval  and then execute deposit
        if (!contracts.refuelDepositer) {
            console.error("Refuel contract not available.");
            return;
        }
        if (new BigNumber(tokenAmount).lte(0)) {
            console.error("Please enter a valid token amount.");
            return;
        }
        if (parsedAddresses.length === 0) {
            console.error("Please enter at least one valid address or smart code.");
            return;
        }

        console.log("Refuel: Distribute Rewards button clicked");

        try {
            // console.log("Deposit Summary:", parsedAddresses, selectedToken.address, tokenAmount);
            const transaction = refuelUserData.isRefuelHost ? contracts.refuelDepositer.methods.depositRewardsToHoldersRefuel(parsedAddresses, selectedToken.address, tokenAmount).send({ from: account })
                : contracts.refuelDepositer.methods.depositRewardsToHolders(parsedAddresses, selectedToken.address, tokenAmount).send({ from: account });

            transaction.on("transactionHash", (hash) => {
                toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
            });

            const tx = await transaction;

            toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });
            setTokenAmount(null);
            setValue('');
            setParsedAddresses([]);

        } catch (error) {
            console.error("Error interacting with the Refuel contract:", error);
            toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Refuel contract: ${error.message}`, life: 3000 });

        }

        setIsLoading(false);
        getData();
    };


    const handleTransferIERC20 = async (tokenAddress, toAddress, amount) => {
        try {
            const web3 = new Web3(window.ethereum);
            const tokenContract = new web3.eth.Contract(ierc20Abi, tokenAddress);
            const transaction = tokenContract.methods.transfer(toAddress, amount).send({ from: account });

            transaction.on("transactionHash", (hash) => {
                toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
            });

            const tx = await transaction;

            toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });
            setTokenAmount(null);
            setValue('');
            setParsedAddresses([]);

        } catch (error) {
            console.error("Error interacting with the Token contract:", error);
            toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Token contract: ${error.message}`, life: 3000 });
        }
        setIsLoading(false);
        getData();
    };

    const buildTokenContract = async (tokenaddress) => {
        const distributorContractInfo = DefiAppService.getSupplementalAbi("Refuel"); //get distributor contract info
        const web3 = new Web3(window.ethereum);

        const contractInstance = new web3.eth.Contract(distributorContractInfo, tokenaddress); //build contract instance
        // console.log(`${contractInstance} contract initialized:`, contractInstance);
        return contractInstance;
    };

    const handleApprove = async (address, tokenAmount) => {
        const tokenContract = await buildTokenContract(selectedToken.address);
        //   console.log("Token contract:", tokenContract);

        //   console.log("Approve Required");

        try {
            //  console.log("Approving tokens:", tokenAmount);
            const transaction = tokenContract.methods.approve(address, new BigNumber(tokenAmount).times(10 ** selectedToken.decimals).toFixed(0).toString()).send({ from: account });

            transaction.on("transactionHash", (hash) => {
                toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
            });

            const tx = await transaction;

            toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

        } catch (error) {
            console.error("Error interacting with the Token contract:", error);
            toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Token contract: ${error.message}`, life: 3000 });
        }
        refreshApproved();
        setIsLoading(false);
    };

    const options = ['Send Crypto', 'Distribute Rewards'];
    const [transferType, setTransferType] = useState(options[0]);

    const renderTotalDistributions = () => {
        return (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(125px, 1fr))', gap: '5px', marginTop: '10px', marginBottom: '10px' }}>
                <div>
                    <div style={refuelHeaderStyle}>
                        Total Distributions
                    </div>
                    <div style={refuelInfoInvertStyle}>
                        {totalDistributions}
                    </div>
                </div>

                <div>
                    <div style={refuelHeaderStyle}>
                        Tokens Per Distribution
                    </div>
                    <div style={refuelInfoInvertStyle}>
                        {parseFloat(tokensPerSmartCode) > 0 ? abbreviateNumber(parseFloat(tokensPerSmartCode)) : 0}
                    </div>
                    <div style={{ fontSize: "12px" }}>
                        {parseFloat(tokensPerSmartCode) > 0 ? formatCurrencyExtended(parseFloat(tokensPerSmartCode) * getTokenPrice(data?.tokensList, selectedToken?.label)) : formatCurrencyExtended(0)}
                    </div>
                </div>

                <div>
                    <div style={refuelHeaderStyle}>
                        Valid Smart Codes
                    </div>
                    <div style={refuelInfoInvertStyle}>
                        {validSmartCodeCount}
                    </div>
                </div>
                <div>
                    <div style={refuelHeaderStyle}>
                        Invalid Smart Codes
                    </div>
                    <div style={refuelInfoInvertStyle}>
                        {invalidSmartCodeInputs}
                    </div>
                </div>
                <div>
                    <div style={refuelHeaderStyle}>
                        Valid Reg. Addresses
                    </div>
                    <div style={refuelInfoInvertStyle}>
                        {validAddressCount}
                    </div>
                </div>
                <div>
                    <div style={refuelHeaderStyle}>
                        Invalid Reg. Addresses
                    </div>
                    <div style={refuelInfoInvertStyle}>
                        {invalidAddressInputs}
                    </div>
                </div>

            </div>
        );
    };


    useEffect(() => {
        setValue('');
        setTokenAmount(null);
        setParsedAddresses([]);
        setDisplayAddress('');
        setDisplaySmartCode('');
        // Reset other relevant states if needed
    }, [transferType]);

    // Conditionally render the input for Step 2 based on transferType
    const renderStepTwoInput = () => {
        if (transferType === "Send Crypto") {
            return (
                <InputText value={value} onChange={(e) => {
                    setValue(e.target.value.replace(/\s+/g, '')); // Remove spaces from input
                    setIsButtonDisabled(false);
                    setDisplayAddress('');
                    setDisplaySmartCode('');
                    if (msgs.current) {
                        msgs.current.clear();
                    }
                }}
                    style={{ width: '100%', marginTop: '5px' }}
                />
            );
        } else {
            return (
                <InputTextarea value={value} onChange={(e) => {
                    setValue(e.target.value);
                    setIsButtonDisabled(false);
                    setDisplayAddress('');
                    setDisplaySmartCode('');
                    if (msgs.current) {
                        msgs.current.clear();
                    }
                }}
                    rows={5} cols={30}
                    style={{ width: '100%', marginTop: '5px' }}
                />
            );
        }
    };

    // const AddressDisplay = ({ address, smartCode }) => (
    //     <div>
    //         {address && <p>{address} <button onClick={() => navigator.clipboard.writeText(address)}>Copy</button></p>}
    //         {/* {smartCode && <p>{smartCode}</p>} */}
    //     </div>
    // );

    const AddressDisplay = ({ address, smartCode, toast }) => {
        const copyToClipboard = (text, label) => {
            navigator.clipboard.writeText(text).then(() => {
                handleCopySuccess(`${label} copied to clipboard!`);
            }, () => {
                handleCopyError(`Failed to copy ${label}.`);
            });
        };

        const handleCopySuccess = (detail) => {
            toast.current.show({ severity: 'success', summary: 'Copied', detail: detail, life: 3000 });
        };

        const handleCopyError = (detail) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: detail, life: 3000 });
        };

        return (
            <div>

                {/* <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: 'white',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', borderRadius: '10px', padding: '5px', marginTop: '10px'
                }}>
                    Address Found: {address}
                    <Button icon="pi pi-copy" style={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        color: 'white',
                        padding: '0px',
                    }} onClick={() => copyToClipboard(address, 'Address')} />
                    <Toast ref={toast} />
                </div> */}

                {address && (
                      <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', borderRadius: '10px', padding: '5px', marginTop: '10px'
                    }}>
                        Address Found: {address}
                        <Button icon="pi pi-copy" style={{
                            border: 'none',
                            backgroundColor: 'transparent',
                            color: 'white',
                            padding: '0px',
                        }} onClick={() => copyToClipboard(address, 'Address')} />
                        <Toast ref={toast} />
                    </div>
                )}
                {smartCode && (
                      <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', borderRadius: '10px', padding: '5px', marginTop: '10px'
                    }}>
                        Smart Code Found: {smartCode}
                        <Button icon="pi pi-copy" style={{
                            border: 'none',
                            backgroundColor: 'transparent',
                            color: 'white',
                            padding: '0px',
                        }} onClick={() => copyToClipboard(smartCode, 'Smart Code')} />
                        <Toast ref={toast} />
                    </div>
                )}
                {/* {address && (
                    <div>
                        {address}
                        <Button icon="pi pi-copy" className="p-button-rounded p-button-success p-ml-2" onClick={() => copyToClipboard(address, 'Address')} aria-label="Copy address" />
                    </div>
                )} */}
                {/* {smartCode && (
                        <div>
                        {smartCode}
                        <Button icon="pi pi-copy" className="p-button-rounded p-button-success p-ml-2" onClick={() => copyToClipboard(smartCode, 'Smart Code')} aria-label="Copy smart code" />
                    </div>
                )} */}
            </div>
        );
    };


    return (
        <Card
            title={
                <div style={refuelOutlineInvertStyle}>Choose Type</div>
            }
            style={{
                ...tokenCardStyle,
                background: 'transparent',
                padding: '0px',
            }}

        >

            <SelectButton value={transferType} onChange={(e) => setTransferType(e.value)} options={options}
            />

            <div style={{ ...tokenCardStyle, marginTop: '20px', marginBottom: '15px' }}>
                <div style={refuelOutlineInvertStyle}>STEP 1</div>
                <div style={refuelHeaderStyle}>
                    Select token to {transferType === options[0] ? 'send as payment' : 'distribute as rewards'}
                </div>
                <ReactSelect
                    selectedToken
                    id="token-selection"
                    options={data?.tokensList?.filter((token) => token.balanceOfHolder > 0 && token.address.toLowerCase() !== "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c".toLowerCase()).sort((a, b) => a.label.localeCompare(b.label))}
                    value={selectedToken}
                    onChange={setSelectedToken}
                    components={makeAnimated()}
                    //className="token-select"
                    placeholder="Select a Token"
                    formatOptionLabel={(option) => formatTokenLabel(data?.dbData, { value: option.value, label: option.label })}
                    //we want border radius to be 10px

                    styles={{
                        container: (provided, state) => ({
                            ...provided,
                            //background: "#333333",
                            border: "none",
                            borderRadius: "20px",
                            boxShadow: "none",
                            color: "white",
                            fontFamily: "Inter, sans-serif",
                            fontSize: "16px",
                            fontWeight: "500",
                            minHeight: "48px",
                            //padding: "0.5rem",
                            "&:hover": {
                                borderColor: "#333333",
                            },
                        }),
                        control: (provided, state) => ({
                            ...provided,
                            //background: "#333333",
                            border: "none",
                            borderRadius: "40px",
                            boxShadow: "none",
                            color: "white",
                            fontFamily: "Inter, sans-serif",
                            fontSize: "16px",
                            fontWeight: "500",
                            minHeight: "48px",
                            padding: "0.5rem",
                            //marginBottom: "0",
                            //paddingBottom: "0",
                            "&:hover": {
                                borderColor: "#333333",
                            },
                        }),
                        menu: (provided, state) => ({
                            ...provided,
                            background: "white",
                            border: "none",
                            borderBottomLeftRadius: "20px",
                            borderBottomRightRadius: "20px",
                            boxShadow: "none",
                            color: "#333333",
                            fontFamily: "Inter, sans-serif",
                            fontSize: "16px",
                            fontWeight: "500",
                            padding: "0.5rem",
                            marginTop: "0px",
                        }),
                        // option: (provided, state) => ({
                        //   ...provided,
                        //   background: state.isFocused ? "#333333" : "#333333",
                        //   color: state.isFocused ? "white" : "white",
                        //   fontFamily: "Inter, sans-serif",
                        //   fontSize: "16px",
                        //   fontWeight: "500",
                        //   padding: "0.5rem",
                        // }),
                        multiValue: (provided, state) => ({
                            ...provided,
                            background: "#333333",
                            color: "white",
                            fontFamily: "Inter, sans-serif",
                            fontSize: "16px",
                            fontWeight: "500",
                            padding: "0.15rem",
                            borderRadius: "20px",
                        }),
                        multiValueLabel: (provided, state) => ({
                            ...provided,
                            color: "white",
                            fontFamily: "Inter, sans-serif",
                            fontSize: "16px",
                            fontWeight: "700",
                        }),
                        multiValueRemove: (provided, state) => ({
                            ...provided,
                            color: "white",
                            fontFamily: "Inter, sans-serif",
                            fontSize: "16px",
                            fontWeight: "500",
                            borderRadius: "20px",
                            "&:hover": {
                                color: "white",
                                cursor: "pointer",
                            },
                        }),
                        indicatorSeparator: (provided, state) => ({
                            ...provided,
                            background: "#333333",
                        }),
                        dropdownIndicator: (provided, state) => ({
                            ...provided,
                            color: "#333333",
                            "&:hover": {
                                color: "#333333",
                            },
                        }),
                        clearIndicator: (provided, state) => ({
                            ...provided,
                            color: "#333333",
                            "&:hover": {
                                color: "#333333",
                            },
                        }),
                        placeholder: (provided, state) => ({
                            ...provided,
                            color: "#333333",
                        }),
                        input: (provided, state) => ({
                            ...provided,
                            color: "#333333",
                        }),

                    }}
                />
            </div>
            <div style={{ ...tokenCardStyle, marginTop: '20px', marginBottom: '15px' }}>
                <div style={refuelOutlineInvertStyle}>STEP 2</div>
                <div style={refuelHeaderStyle}>
                    {transferType === "Send Crypto" ? 'Enter a Smart Code or Address' : 'Enter Smart Codes and/or Addresses'}
                </div>
                {renderStepTwoInput()}
                <Button
                    onClick={() => {
                        setIsCalculating(true);
                        setIsButtonDisabled(true); // Disable button on click
                        refreshApproved();
                    }}
                    label="Validate Address/Smart Code"
                    rounded
                    severity="primary"
                    size="small"
                    disabled={isButtonDisabled || value.trim() === ''}
                    style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}
                />
                {(displayAddress || displaySmartCode) && isButtonDisabled && transferType === "Send Crypto" && <AddressDisplay address={displayAddress} smartCode={displaySmartCode} toast={toast} />}
                <Messages ref={msgs} />

            </div>

            <div style={{ ...tokenCardStyle, marginTop: '20px', marginBottom: '15px' }}>
                <div style={refuelOutlineInvertStyle}>STEP 3</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', }}>
                    <div style={refuelHeaderStyle}>
                        Enter Token Amount
                    </div>
                    <div style={{ ...refuelHeaderStyle, textAlign: 'right', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <div>Your Balance</div>
                        <strong>
                            {selectedToken ? formatDecimals(data?.tokensList?.find((token) => token?.address?.toLowerCase() === selectedToken?.address?.toLowerCase()).balanceOfHolder, selectedToken.decimals) : 0}
                            {'('}
                            {selectedToken ?
                                formatCurrencyExtended((data?.tokensList?.find((token) => token?.address?.toLowerCase() === selectedToken?.address?.toLowerCase()).balanceOfHolder / (10 ** selectedToken.decimals)) * getTokenPrice(data?.tokensList, selectedToken?.label)) : formatCurrencyExtended(0)}
                            {')'}
                        </strong>
                    </div>
                </div>


                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <InputNumber
                        value={tokenAmount || null}
                        onChange={(e) => setTokenAmount(e.value)}
                        minFractionDigits={0}
                        maxFractionDigits={selectedToken ? selectedToken.decimals : 0}
                        min={0}
                        max={selectedToken ? selectedToken.balanceOfHolder / (10 ** selectedToken.decimals) : 0}
                        showButtons
                        step={step}
                        inputId="stacked-buttons"
                        size="small"
                        style={{ width: 'calc(100% - 20%)', justifyContent: 'center', marginTop: '10px' }} // adjusted width
                        decrementButtonClassName="p-button-warning"
                        incrementButtonClassName="p-button-warning"
                    />
                    <Button
                        label="Max"
                        text
                        severity="warning"
                        onClick={() => {
                            if (selectedToken) {
                                setTokenAmount(selectedToken.balanceOfHolder / (10 ** selectedToken.decimals));
                            }
                        }}
                        style={{ marginLeft: '10px', marginTop: '10px' }} // adjust styling as needed
                    />

                </div>
                {transferType === options[0] &&
                    <>
                        {parseFloat(tokenAmount) > 0 && parsedAddresses[0] && <div style={{
                            border: '1px solid #333333',
                            backgroundColor: 'black',
                            padding: '10px',
                            borderRadius: '20px',
                            marginTop: '10px',
                            color: 'white',
                            fontSize: '12px',
                            display: 'flex', justifyContent: 'center', marginTop: '10px'
                        }}>
                            Sending {formatCurrencyExtended(parseFloat(tokenAmount) * getTokenPrice(data?.tokensList, selectedToken?.label))} {selectedToken?.label} to {formatWalletAddress(parsedAddresses[0])}
                        </div>}

                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                            {isLoading ? <div style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}><Progress
                                indeterminated
                                value={30}
                                color="gradient"
                                status="secondary"
                                size="xl"

                            /></div> :
                                <Button
                                    rounded
                                    severity="warning"
                                    onClick={() => { handleTransferIERC20(selectedToken.address, parsedAddresses[0], new BigNumber(tokenAmount).times(10 ** selectedToken.decimals).toFixed(0).toString()); setIsLoading(true); }}
                                    size="small"
                                    style={{ width: '100%', justifyContent: 'center', marginTop: '10px', marginBottom: '20px' }}
                                    disabled={tokenAmount === null || tokenAmount === 0 || !isButtonDisabled || parsedAddresses.length === 0}
                                >
                                    Send
                                </Button>}
                        </div>
                    </>
                }
            </div>
            {transferType !== options[0] && <div style={{ ...tokenCardStyle, marginTop: '20px', marginBottom: '15px' }}>
                <div style={refuelOutlineInvertStyle}>SUMMARY</div>
                {renderTotalDistributions()}


                {isLoading ? <div style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}><Progress
                    indeterminated
                    value={30}
                    color="gradient"
                    status="secondary"
                    size="xl"

                /></div> : <>
                    {selectedToken && <div style={{ marginTop: '10px' }}>
                        <Message severity="info" text="Note: Please ensure no transfer tax. Only direct transfers supported at this moment" />
                    </div>}

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        {//!isLoading && !approved &&
                            <Button
                                rounded
                                severity="warning"
                                onClick={() => { handleApprove(contracts.refuelDepositer._address, tokenAmount); setIsLoading(true); }}
                                size="small"
                                style={{ width: '48%', justifyContent: 'center', marginTop: '10px', marginBottom: '20px' }}
                                disabled={tokenAmount === null || tokenAmount === 0 || !isButtonDisabled || approved || parsedAddresses.length === 0}
                            >
                                {!isButtonDisabled ? "Validate to Enable Step 4" : "Step 4: Approve"}
                            </Button>}

                        {//!isLoading && approved &&
                            <Button
                                rounded
                                severity="warning"
                                onClick={() => { handleDeposit(new BigNumber(tokenAmount).times(10 ** selectedToken.decimals).toFixed(0).toString()); setIsLoading(true); }}
                                size="small"
                                style={{ width: '48%', justifyContent: 'center', marginTop: '10px', marginBottom: '20px' }}
                                disabled={tokenAmount === null || tokenAmount === 0 || new BigNumber(tokenAmount).times(10 ** selectedToken.decimals).gt(new BigNumber(selectedToken?.balanceOfHolder)) || !isButtonDisabled || parsedAddresses.length === 0 || !approved}
                            //disabled
                            >
                                {!approved ?
                                    (!isButtonDisabled ? "Validate to Enable Step 5" : "Approve to Enable Step 5")
                                    : "Step 5: Distribute"
                                }
                            </Button>}
                    </div>
                </>}


            </div>}

            <Toast ref={toast} />
        </Card>
    );
}

export default AdminSelection;
